export default "__VITE_ASSET__Bbw80uV1__"